import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseEventInboxMemberAdded } from 'entities/Inbox/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { eventEmitterStore } from 'entities/EventEmitter'

export const useEventInboxMemberAdded = () => {
  const { inboxesStore, websocket } = useEntitiesContext()
  const handle = (data: IResponseEventInboxMemberAdded) => {
    const inboxesCount = inboxesStore.sharedInboxes.length

    inboxesStore.addItem(data)

    if (!inboxesCount) {
      eventEmitterStore.emit('load_conversation_list')
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.InboxMemberAdded, handle), [])
}
